// src/components/sdk/components/UsageContent.tsx
import React from 'react';
import { AppBrief, UsageContentProps, UsageContentState, UserBrief } from '../SdkInterface';
import { UsageStats } from './UsageStats';
import { UsageFilter } from './UsageFilter';
import { UsageLogTable } from './UsageLogTable';
import { Collapse } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

interface ExtendedUsageContentProps extends UsageContentProps {
    users?: UserBrief[];
    appBrief?: AppBrief[];
    isMobile?: boolean;
}

interface ExtendedUsageContentState extends UsageContentState {
    panelExpanded?: boolean;
}

export class UsageContent extends React.Component<ExtendedUsageContentProps, ExtendedUsageContentState> {
    constructor(props: ExtendedUsageContentProps) {
        super(props);
        this.state = {
            panelExpanded: false,  // 默认收起
        };
    }

    // 处理面板展开/收缩变化
    handlePanelChange = (keys: string | string[]) => {
        const expanded = Array.isArray(keys) ? keys.length > 0 : !!keys;
        this.setState({ panelExpanded: expanded });
    };

    render() {
        const {
            t,
            usageLogs,
            usageTotal,
            usageTotalUsage,
            usagePage,
            usagePageSize,
            usageTotalPages,
            usageLoading,
            usageFilter,
            onRefresh,
            onFilterApply,
            onFilterReset,
            onPageChange,
            usageFormRef,
            users = [],
            appBrief = [],
            isMobile = false,
        } = this.props;

        const { panelExpanded = false } = this.state;

        // 桌面端保持原样
        if (!isMobile) {
            return (
                <div style={{ overflow: 'hidden' }}>
                    <UsageStats
                        t={t}
                        usageTotal={usageTotal}
                        usageTotalUsage={usageTotalUsage}
                        usagePage={usagePage}
                        usageTotalPages={usageTotalPages}
                        isMobile={isMobile}
                    />

                    <UsageFilter
                        t={t}
                        usageFilter={usageFilter}
                        onFilterApply={onFilterApply}
                        onFilterReset={onFilterReset}
                        usageFormRef={usageFormRef}
                        users={users}
                        appBrief={appBrief}
                        isMobile={isMobile}
                        onDeleted={onRefresh}
                    />

                    <UsageLogTable
                        t={t}
                        usageLogs={usageLogs}
                        usageLoading={usageLoading}
                        usageTotal={usageTotal}
                        usagePage={usagePage}
                        usagePageSize={usagePageSize}
                        onPageChange={onPageChange}
                        isMobile={isMobile}
                        panelExpanded={false}
                    />
                </div>
            );
        }

        // 移动端：一个折叠面板包含统计和筛选
        return (
            <div style={{ overflow: 'hidden' }}>
                <Collapse
                    defaultActiveKey={[]}
                    ghost
                    style={{
                        background: 'transparent',
                        marginBottom: 12,
                    }}
                    expandIconPosition="end"
                    onChange={this.handlePanelChange}
                >
                    <Panel
                        header={
                            <span>
                                <FilterOutlined style={{ marginRight: 8 }} />
                                {t('sdk.usage.filterAndStats') || '筛选与统计'}
                            </span>
                        }
                        key="filterAndStats"
                        style={{
                            background: '#fafafa',
                            borderRadius: 8,
                            border: '1px solid #e8e8e8',
                            overflow: 'hidden',
                        }}
                    >
                        <div style={{ padding: '4px 0' }}>
                            <UsageStats
                                t={t}
                                usageTotal={usageTotal}
                                usageTotalUsage={usageTotalUsage}
                                usagePage={usagePage}
                                usageTotalPages={usageTotalPages}
                                isMobile={isMobile}
                            />

                            <div style={{ marginTop: 12 }}>
                                <UsageFilter
                                    t={t}
                                    usageFilter={usageFilter}
                                    onFilterApply={onFilterApply}
                                    onFilterReset={onFilterReset}
                                    usageFormRef={usageFormRef}
                                    users={users}
                                    appBrief={appBrief}
                                    isMobile={isMobile}
                                    onDeleted={onRefresh}
                                />
                            </div>
                        </div>
                    </Panel>
                </Collapse>

                <UsageLogTable
                    t={t}
                    usageLogs={usageLogs}
                    usageLoading={usageLoading}
                    usageTotal={usageTotal}
                    usagePage={usagePage}
                    usagePageSize={usagePageSize}
                    onPageChange={onPageChange}
                    isMobile={isMobile}
                    panelExpanded={panelExpanded}
                />
            </div>
        );
    }
}

export default UsageContent;